"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab["default"];
  }
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _Tab = _interopRequireDefault(require("./Tab/Tab.index"));

var _Tabs = _interopRequireDefault(require("./Tabs.context"));

var _Tabs2 = require("./Tabs.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tabs = function Tabs(props) {
  var children = props.children;
  var tabsRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tabHeader = _useState2[0],
      setTabHeader = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeItem = _useState4[0],
      setActiveItem = _useState4[1];

  (0, _react.useEffect)(function () {
    var headers = [];

    _react.Children.forEach(children, function (element) {
      if (! /*#__PURE__*/(0, _react.isValidElement)(element)) return;
      var _element$props = element.props,
          active = _element$props.active,
          title = _element$props.title;
      headers.push(title);

      if (active) {
        setActiveItem(title);
      }
    });

    setTabHeader(headers);
  }, [children]);
  var changeTab = (0, _react.useCallback)(function (event, item) {
    event.preventDefault();
    setActiveItem(item);
  }, []);
  (0, _react.useEffect)(function () {
    if (!activeItem && tabHeader.length > 0) {
      setActiveItem(tabHeader[0]);
    }
  }, [activeItem, tabHeader]);
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"].Provider, {
    value: {
      activeItem: activeItem,
      provider: 'tabs'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Tabs2.StyledTabs, null, /*#__PURE__*/_react["default"].createElement(_Tabs2.StyledTabsHeader, null, /*#__PURE__*/_react["default"].createElement("nav", null, /*#__PURE__*/_react["default"].createElement("ul", null, tabHeader.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Tabs2.StyledTabsHeaderItem, {
      key: (0, _autobahnUtilities.slugify)(item),
      active: item === activeItem
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#".concat((0, _autobahnUtilities.slugify)(item)),
      onClick: function onClick(event) {
        return changeTab(event, item);
      },
      key: item
    }, item));
  }))))), /*#__PURE__*/_react["default"].createElement(_Tabs2.StyledTabsBody, {
    ref: tabsRef
  }, children));
};

Tabs.Tab = _Tab["default"];
var tabItem = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_Tab["default"]])
});
Tabs.propTypes = {
  /** Tabs to be rendered. They need to be of type Tab (Tabs/Tab) */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(tabItem), tabItem]).isRequired
};
Tabs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tabs",
  "props": {
    "children": {
      "description": "Tabs to be rendered. They need to be of type Tab (Tabs/Tab)",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "tabItem"
          }
        }, {
          "name": "custom",
          "raw": "tabItem"
        }]
      },
      "required": true
    }
  }
};
var _default = Tabs;
exports["default"] = _default;